import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 8",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#ffffff",
			fillRule: "nonzero",
			d: "M7 3.05L11.95 8l1.414-1.414L7 .222.636 6.586 2.05 8z"
		})
	})
});
export default SvgArrowUp;
